export default __webpack_public_path__ + "static/media/vkSignUp.8f59a493.png";